import { createSlice } from '@reduxjs/toolkit';
import { LAYOUT } from 'src/constants/styles';

export const DEFAULT_APP_VERSION = '1.0.0';

const initialState = {
  memberType: '',
  householdMember: {},
  isLoading: false,
  expandedPageContent: false,
  forceExpanded: false,
  appVersionAlertVisible: false,
  headerHeight: LAYOUT.totalDefaultHeaderHeight, // Default header height with buffer
};

export const slice = createSlice({
  name: 'Main Slice',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setExpandedContent(state, action) {
      state.expandedPageContent = action.payload;
    },

    setForceExpanded(state, action) {
      state.forceExpanded = action.payload;
    },

    setHeaderHeight(state, action) {
      state.headerHeight = action.payload;
    },

    // SET HOUSEHOLD MEMBER TYPE
    setMemberType(state, action) {
      state.isLoading = false;
      state.memberType = action.payload;
    },

    setHouseholdMember(state, action) {
      state.isLoading = false;
      state.householdMember = action.payload;
    },

    resetMemberType(state) {
      state.isLoading = false;
      state.memberType = '';
    },
  },
});

export const {
  setExpandedContent,
  setForceExpanded,
  setHeaderHeight,
  setMemberType,
  setHouseholdMember,
} = slice.actions;

export default slice.reducer;
